export const enum BookingForEnum {
  Myself = 'myself',
  SomeoneElse = 'someoneElse',
  MyselfAndFamily = 'myselfAndFamily',
  MyselfAndPartner = 'myselfAndPartner',
}
